import { Service } from 'protocol/api/billing_new/dto_services_new_pb';

export const serviceIsVisible = (service: Service) => service.Visible;

